import { addressLine } from '@core/helpers/address.helper';
import { Installation } from '@core/models/installation.model';

export function installationAddress(installation: Installation | null): string {
  return installation?.location ? addressLine(installation.location) : '';
}

export function installationStreet(installation: Installation): string {
  const { street, streetNumber, streetNumberAddition } = installation.location;
  return addressLine({ street, streetNumber, streetNumberAddition });
}

// The location stores an ISO 3166 code; anything else is shown as it is stored.
export function countryName(country: string | null | undefined, language: string): string {
  if (!country || !/^[A-Za-z]{2}$/.test(country)) return country ?? '';
  try {
    return (
      new Intl.DisplayNames([language], { type: 'region' }).of(country.toUpperCase()) ?? country
    );
  } catch {
    return country;
  }
}
